module.exports = __webpack_public_path__ + "media/images/consumer/components/progress-bar/step-05@2x-75e247754d18062792414ec737f3ae2e.webp";